import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import { Field, Form, Formik, FormikConfig, FormikValues } from "formik";
import React, { useState } from "react";
import { mixed, number, object } from "yup";
import { MyButton, MySecondButton } from "../../styles/HomeStyles";

export function FormikStepper({ children, isLoading, ...props }) {
  const childrenArray = React.Children.toArray(children);
  const [step, setStep] = useState(0);
  const currentChild = childrenArray[step];
  const [completed, setCompleted] = useState(false);

  function isLastStep() {
    return step === childrenArray.length - 1;
  }

  const hadleSubmit = async (values, helpers) => {
    if (isLastStep()) {
      await props.onSubmit(values, helpers);
      setCompleted(true);
    } else {
      setStep((s) => s + 1);
      helpers.setTouched({});
    }
  };

  return (
    <Formik
      {...props}
      validationSchema={currentChild.props.validationSchema}
      onSubmit={hadleSubmit}
    >
      <Form autoComplete="off">
        <Box
          sx={{
            justifyContent: "center",
          }}
        >
          <Box sx={{ maxWidth: "800px", margin: "0 auto" }}>
            <Stepper alternativeLabel activeStep={step}>
              {childrenArray.map((child, index) => (
                <Step
                  key={child.props.label}
                  completed={step > index || completed}
                  sx={{
                    "& .MuiStepLabel-root .Mui-completed": {
                      color: "secondary.dark", // circle color (COMPLETED)
                    },
                    "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                      {
                        color: "grey.500", // Just text label (COMPLETED)
                      },
                    "& .MuiStepLabel-root .Mui-active": {
                      color: "secondary.main", // circle color (ACTIVE)
                    },

                    "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                      fill: "common.white", // circle's number (ACTIVE)
                    },
                  }}
                >
                  <StepLabel>{child.props.label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>

        {currentChild}

        <Grid container spacing={2} justifyContent="center" mt={2}>
          <Grid item>
            <MySecondButton
              disabled={isLoading || step <= 0}
              size="large"
              onClick={() => setStep((s) => s - 1)}
            >
              Retourn
            </MySecondButton>
          </Grid>

          <Grid item>
            <MyButton
              endIcon={isLoading ? <CircularProgress size="1rem" /> : null}
              disabled={isLoading}
              type="submit"
              size="large"
            >
              {isLoading ? "Chargement" : isLastStep() ? "Envoyer" : "Suivant"}
            </MyButton>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
}

export function FormikStep({ children }) {
  return <>{children}</>;
}
